/**
 * File: /home/cordova03/projects/educore_3.5/src/app/report_cards/approve_reports/approveReportsModule.js
 * Project: /home/cordova03/projects/educore_3.5
 * Created Date: Monday, December 10th 2018, 12:02:16 pm
 * Author: Naveen Nazimudeen N
 * -----
 * Last Modified: Mon Dec 10 2018
 * Modified By: Naveen Nazimudeen N
 * -----
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
import controller from './controllers/approveReportsController';

var module = angular.module('ApproveReportsModule', [
    //import modules
])
.controller('approveReports', controller);


import template from './views/approve-reports.html';

// module.config(function ($stateProvider) {
//     "ngInject";

//     $stateProvider
//         .state('approveReports', {
//             parent: 'app',
//             url: '/report-card-approvals',
//             views: {
//                 '@': {
//                     template: template,
//                     controller: controller,
//                     controllerAs: 'reportCardApprovalCtrl'
//                 }
//             }
//         })

// });


// WEBPACK FOOTER //
// ./src/app/report_cards/approve_reports/approveReportsModule.js